import React from 'react';
import firebase from '../../firebase';
import AvatarEditor from 'react-avatar-editor';
import { connect } from 'react-redux';
import { Grid, Header, Dropdown, Image, Modal } from 'semantic-ui-react';


class UserPanel extends React.Component {
    state = {
        user: this.props.currentUser,
        modal: false,
        previewImage: '',
        croppedImage: '',
        blob: '',
        uploadedCroppedImage: '',
        storageRef: firebase.storage().ref(),
        userRef: firebase.auth().currentUser,
        usersRef: firebase.database().ref('allUsers'),
        metadata: {
            contentType: 'image/jpeg'
        }
    };

    openModal = () => this.setState({ modal: true });

    closeModal = () => this.setState({ modal: false });

    dropdownOptions = () => [
        /*{
            key: "user",
            text: <span style={{
                fontFamily: 'proxima-nova, sans-serif',
                fontWeight: 600,
                fontStyle: 'normal',
                fontSize: '16px'
            }}>Signed in as <strong>{this.state.user.displayName}</strong></span>,
            disabled: true
        },*/
        {
            key: "avatar",
            text: <span onClick={this.openModal} style={{
                fontFamily: 'proxima-nova, sans-serif',
                fontWeight: 600,
                fontStyle: 'normal',
                fontSize: '16px',
                color: "#444444"
            }}>Change Avatar</span>
        },
        {
            key: "signout",
            text: <span onClick={this.handleSignout} 
            style={{
                fontFamily: 'proxima-nova, sans-serif',
                fontWeight: 600,
                fontStyle: 'normal',
                fontSize: '16px',
                color: "#444444"
            }}>Log Out</span>
        }
    ];

    uploadCroppedImage = () => {
        const{ storageRef, userRef, blob, metadata } = this.state;


        storageRef
            .child(`avatars/user/${userRef.uid}`)
            .put(blob, metadata)
            .then(snap => {
                snap.ref.getDownloadURL().then(downloadURL => {
                    this.setState({ uploadedCroppedImage: downloadURL }, () => 
                    this.changeAvatar())
                })
            })
    };

    changeAvatar = () => {
        this.state.userRef
            .updateProfile({
                photoURL: this.state.uploadedCroppedImage
            })
            .then(() => {
                console.log('PhotoURL updated');
                this.closeModal();
            })
            .catch(err => {
                console.error(err);
            })

        this.state.usersRef
            .child(this.state.user.uid)
            .update({ avatar: this.state.uploadedCroppedImage })
            .then(() => {
                console.log('User avatar updated');
            })
            .catch(err => {
                console.error(err);
            })
    }

    handleChange = event => {
        const file = event.target.files[0];
        const reader = new FileReader();

        if (file) {
            reader.readAsDataURL(file);
            reader.addEventListener('load', () => {
                this.setState({ previewImage: reader.result });
            });
        }
    };

    handleCropImage = () => {
        if (this.avatarEditor) {
            this.avatarEditor.getImageScaledToCanvas().toBlob(blob => {
                let imageUrl = URL.createObjectURL(blob);
                this.setState({
                    croppedImage: imageUrl,
                    blob
                });
            });
        }
    };

    handleSignout = () => {
        firebase
            .auth()
            .signOut()
            .then(() => console.log("signed out!"));
    };

    render() {
        const { user, modal, previewImage, croppedImage } = this.state;

        return (
            <Grid style={{ background: '#FC7E4B', paddingBottom: '25px'}}>
                <Grid.Column>

                    {/*USER DROPDOWN */}
                    <Header style={{ 
                        paddingLeft: '0px', 
                        fontFamily: 'proxima-nova, sans-serif', 
                        fontWeight: 600, 
                        fontStyle: 'normal',
                        fontSize: '17px',
                        color: '#fff',
                        marginBottom: '0'
                     }} 
                     className="userPanelImageName"
                        >
                        <Dropdown trigger={
                            <span>
                                <Image src={user.photoURL} spaced="right" style={{ borderRadius: '50px', background: '#fff' }} avatar />
                                {user.displayName}
                            </span>
                        } options={this.dropdownOptions()}/>
                    </Header>

                    {/* Change User Avatar Modal */}
                    <Modal basic open={modal} onClose={this.closeModal}>
                <Modal.Header>Change Avatar</Modal.Header>
                <Modal.Content className="modalContent">
                    <label 
                        style={{
                            fontFamily: 'proxima-nova, sans-serif',
                            fontWeight: 400,
                            fontStyle: 'normal',
                            fontSize: '13.5px',
                            color: '#F0F0F0'
                        }}
                        className="modalLabel fileUploadLabel"
                        >File types: JPG, PNG
                    </label>
                    <input
                        onChange={this.handleChange}
                        name="previewImage"
                        type="file"
                        style={{
                            fontFamily: 'proxima-nova, sans-serif',
                            fontWeight: 400,
                            fontStyle: 'normal',
                            opacity: '1',
                            color: '#4c4c4c',
                            paddingTop: '6px'
                        }}
                        className="modalInput fileUploadInput"
                    />

                    <Grid centered stackable columns={2}>
                        <Grid.Row centered>
                            <Grid.Column className="ui centered aligned grid">
                               {previewImage && (
                                   <AvatarEditor
                                        ref={ node => (this.avatarEditor = node)}
                                        image={previewImage}
                                        style={{
                                            width: '335px',
                                            height: '300px'
                                        }}
                                        border={5}
                                        scale={1}
                                   />
                               )}

                            </Grid.Column>
                            <Grid.Column>
                                {croppedImage && (
                                    <Image
                                        style={{ margin: '3.5em auto'}}
                                        width={100}
                                        height={100}
                                        src={croppedImage}
                                    />
                                )}
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Actions>
                    {croppedImage && <button
                        onClick={this.uploadCroppedImage}
                        className="addButton" 
                        style={{
                            fontFamily: 'proxima-nova, sans-serif',
                            fontWeight: 600,
                            fontStyle: 'normal'
                        }}
                    >Change</button>}

                    <button
                        onClick={this.handleCropImage}
                        className="previewButton" 
                        style={{
                            fontFamily: 'proxima-nova, sans-serif',
                            fontWeight: 600,
                            fontStyle: 'normal'
                        }}
                    >Preview</button>

                    <button
                        className="cancelButton" 
                        style={{
                            fontFamily: 'proxima-nova, sans-serif',
                            fontWeight: 600,
                            fontStyle: 'normal'
                        }}
                        onClick={this.closeModal}
                    >Cancel</button>
                </Modal.Actions>
            </Modal>

                </Grid.Column>
            </Grid>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.currentUser
});

export default connect(mapStateToProps)(UserPanel);


// WEBPACK FOOTER //
// ./src/components/SidePanel/UserPanel.js